import { SettingActionType } from '../action-types/settingTypes';
import { SettingActions } from '../actions/settingTypes';
import { Dispatch } from 'redux';

export const setEnvironment = (environment: Stage) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_ENVIRONMENT,
      payload: environment,
    });
  };
};

export const setPartnerId = (partnerId: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_PARTNER_ID,
      payload: partnerId,
    });
  };
};

export const setTipmode = (tipmode: boolean) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_TIPMODE,
      payload: tipmode,
    });
  };
};

export const setPromptAgent = (promptagent: boolean) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_PROMPT_AGENT,
      payload: promptagent,
    });
  };
};

export const setExternalReference = (externalReference: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_EXTERNAL_REFERENCE,
      payload: externalReference,
    });
  };
};

export const setCurrentSteps = (steps: Array<number>) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_CURRENT_STEPS,
      payload: steps,
    });
  };
};

export const setAppName = (appName: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_APP_NAME,
      payload: appName,
    });
  };
};

export const setSessionId = (sessionId: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_SESSION_ID,
      sessionId: sessionId,
    });
  };
};

export const setUuid = (uuid: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_UUID,
      payload: uuid,
    });
  };
};

export const setLoggerLink = (loggerLink: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_LOGGER_LINK,
      payload: loggerLink,
    });
  };
};

export const setLanguage = (language: LanguageType) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_LANGUAGE,
      payload: language,
    });
  };
};

export const setConfirmationTarget = (confirmationTarget: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_CONFIRMATION_TARGET,
      payload: confirmationTarget,
    });
  };
};

export const setConfirmationType = (confirmationType: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_CONFIRMATION_TYPE,
      payload: confirmationType,
    });
  };
};

export const setRebound = (rebound: Rebound) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_REBOUND,
      payload: rebound,
    });
  };
};

export const setPrecontractualQuoteId = (precontractualQuoteId: number) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_PRECONTRACTUAL_QUOTEID,
      payload: precontractualQuoteId,
    });
  };
};

export const setAgencyInformation = (agencyInformation: AgencyInformationType) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_AGENCY_INFORMATION,
      payload: agencyInformation,
    });
  };
};

export const setCurrentDate = (currentDate: string) => {
  return (dispatch: Dispatch<SettingActions>) => {
    dispatch({
      type: SettingActionType.SET_CURRENT_DATE,
      payload: currentDate,
    });
  };
};
